<div class="chat-input-container">
  <div class="chat-input">
    <textarea
      [(ngModel)]="value"
      (input)="onInputChange(value, $event)"
      (keydown)="onKeyDown($event)"
      [disabled]="disabled"
      placeholder="Start the conversation..."
      rows="1"
      class="chat-input-textarea">
    </textarea>
    <app-titan-icon-button
      [variant]="'primary'"
      [iconVariant]="'Up'"
      [iconSize]="'m'"
      [isDisabled]="!value.trim() || disabled"
      (onPress)="onSend()">
    </app-titan-icon-button>
  </div>
</div>
